import { Injectable } from '@angular/core'

import { FundCategoryModel } from './models/fund-category-model'
import { LowerLvlCategoryFundRuleModel } from './models/lower-lvl-category-fund-rule.model'
import { FundRuleName } from './rules/fund-rule-name'

@Injectable({
  providedIn: 'root',
})
export class FundClassificationProcess {
  private ruleList: LowerLvlCategoryFundRuleModel[] = []
  private fundClassificationMap: Map<FundRuleName, FundCategoryModel> = new Map<
    FundRuleName,
    FundCategoryModel
  >()
  getFundClassificationMap(): Map<FundRuleName, FundCategoryModel> {
    return this.fundClassificationMap
  }

  registerRules(fundRule: LowerLvlCategoryFundRuleModel) {
    this.ruleList.push(fundRule)
  }

  executeClassificationProcess(product: any) {
    let fundGroup: FundCategoryModel
    this.ruleList.forEach((lowerLvlCatModel: LowerLvlCategoryFundRuleModel) => {
      if (lowerLvlCatModel.fundRule.isRuleApplicable(product)) {
        if (
          !this.fundClassificationMap.get(lowerLvlCatModel.fundRule.ruleName)
        ) {
          fundGroup = new FundCategoryModel(
            lowerLvlCatModel.catLvl1Name,
            lowerLvlCatModel.catLvl2Name,
            lowerLvlCatModel.catLvl3Name,
          )
          this.fundClassificationMap.set(
            lowerLvlCatModel.fundRule.ruleName,
            fundGroup,
          )
        }
        this.fundClassificationMap
          .get(lowerLvlCatModel.fundRule.ruleName)
          .fundDtlAry.push(product)
      }
    })
  }
}
